import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '@api/settings.service';
import {
  SendStatisticsService,
  StatisticsActionKey,
  StatisticsContextEnum,
} from '@shared/api/send-statistics.service';
import { slideRightAnimation } from '@shared/animations/animations';
import { OrderState } from '@shared/states/order.state';
import { UserState } from '@shared/states/user.state';
import { BreakpointTypeEnum } from '@shared/types/screen-breakpoints';
import { MainSidebarState } from './main-sidebar.state';
import { MainSidebarLink } from './main-sidebar.types';
import { ScreenLessThanPipe } from '@shared/pipes/screen-less-than.pipe';

@Component({
  selector: 'app-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideRightAnimation],
  host: {
    '[class.mobile]': `SCREEN_PIPE.transform(settingsService.screenBreakpoint$.value, BreakpointTypeEnum.HalfSmall)`,
  },
})
export class MainSidebarComponent {
  public readonly BreakpointTypeEnum = BreakpointTypeEnum;
  public SCREEN_PIPE = new ScreenLessThanPipe();
  public readonly StatisticsActionKey = StatisticsActionKey;

  public readonly topLinks: MainSidebarLink[] = [
    {
      label: 'Главная',
      route: '/configurator/dashboard',
      icon: '/assets/img/nav/home.svg',
      exact: true,
      iconType: 'none',
      actionKey: StatisticsActionKey.LOAD,
    },
  ];

  public readonly estimateLinks: MainSidebarLink[] = [
    {
      label: 'Параметры ремонта',
      route: '/configurator/repair-composition/repair-parameters',
      icon: '/assets/img/nav/parameters.svg',
      iconType: 'none',
      actionKey: StatisticsActionKey.OPTIONS_TAB,
    },
    {
      label: 'План работ',
      route: '/configurator/repair-composition/repair-stages',
      icon: '/assets/img/nav/works-plan.svg',
      iconType: 'none',
      actionKey: StatisticsActionKey.PHASE_ESTIMATE,
    },
    {
      label: 'Смета',
      route: '/configurator/repair-composition/materials',
      icon: '/assets/img/nav/smeta.svg',
      iconType: 'none',
      actionKey: StatisticsActionKey.ESTIMATE_SCREEN,
    },
  ];

  public readonly additionalLinks: MainSidebarLink[] = [
    {
      label: 'Параметры квартиры',
      route: '/configurator/flat',
      icon: '/assets/img/nav/flat-parameters.svg',
      iconType: 'none',
      actionKey: StatisticsActionKey.LINK,
    },
    {
      label: 'Дизайн и чертежи',
      route: '/configurator/style',
      icon: '/assets/img/nav/design.svg',
      iconType: 'none',
      actionKey: StatisticsActionKey.DESIGN,
    },
    {
      label: 'Мастера',
      route: '/configurator/brigade',
      icon: '/assets/img/nav/contractors.svg',
      iconType: 'none',
      actionKey: StatisticsActionKey.BRIGADE_SCREEN_LINK,
    },
  ];

  public readonly profileLink: MainSidebarLink = {
    label: 'Личный кабинет',
    route: '/account/profile',
    icon: '/assets/img/nav/profile.svg',
    iconType: 'none',
    actionKey: StatisticsActionKey.PERSONALITY_SCREEN,
  };

  constructor(
    public orderState: OrderState,
    public settingsService: SettingsService,
    public userState: UserState,
    public mainSidebarState: MainSidebarState,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private sendStatistics: SendStatisticsService,
  ) {}

  public get isDesktop(): boolean {
    return !this.isCompactScreen;
  }

  public get isMobileOpened(): boolean {
    return this.mainSidebarState.mobileOpened$.value;
  }

  public get isCollapsed(): boolean {
    return this.mainSidebarState.collapsed$.value;
  }

  public toggleCollapsed(): void {
    this.mainSidebarState.toggle();
  }

  public closeMobileSidebar(): void {
    this.mainSidebarState.closeMobile();
  }

  public handleLinkClick(actionKey: StatisticsActionKey | null): void {
    if (this.isCompactScreen) {
      this.closeMobileSidebar();
    }

    if (actionKey) {
      this.sendStatistics.sendStat(actionKey, StatisticsContextEnum.SIDEBAR_MENU).subscribe();
    }
  }

  public trackByRoute(_: number, item: MainSidebarLink): string {
    return item.route;
  }

  private get isCompactScreen(): boolean {
    return [
      BreakpointTypeEnum.XXSmall,
      BreakpointTypeEnum.XSmall,
      BreakpointTypeEnum.Small,
      BreakpointTypeEnum.HalfSmall,
    ].includes(this.settingsService.screenBreakpoint$.value);
  }
}
